// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"26ea3268","142":"baf66f10","453":"c5362081","530":"dd647c47","686":"bcc1fcd0","721":"fee6e9a9","871":"f8dc2906","895":"67133e4a"}[chunkId] + ".chunk.js";
};